export default __webpack_public_path__ + "static/media/pie-chart.b208d45c.svg";